
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { useAdminStore } from './stores/admin';
import { useOrdersStore } from './stores/orders';
import { useRecordsStore } from './stores/records';
import { useCustomersStore } from '@/stores/customers';
import { useStaffsStore } from '@/stores/staffs';
import { useProductStore } from '@/stores/products';
import { useCategoriesStore } from './stores/categories';
import { useSettingStore } from './stores/settings';

import './assets/css/global.css'

import { createPinia } from 'pinia'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faNavicon, faSpinner, faHome, faCartShopping, faSearch, faUtensils, faHotel, faBurger, faPeopleRoof, faGraduationCap, faShop, faHouse, faUser, faTrash, faExclamation, faArrowRightLong, faXmark, faArrowLeftLong, faCircleCheck, faChevronLeft, faChevronRight, faBoxOpen, faUserTie, faEnvelope, faSignOut, faGauge, faUsers, faCalculator, faSort, faPhone, faLocation, faCamera, faMessage, faChartLine, faUserCog, faMobilePhone, faPlus, faMobileScreenButton} from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add( faNavicon, faSpinner, faHome, faCartShopping, faSearch, faUtensils, faHotel, faBurger, faPeopleRoof, faGraduationCap, faShop, faHouse, faUser, faTrash, faExclamation, faArrowRightLong, faXmark, faArrowLeftLong, faCircleCheck, faChevronLeft, faChevronRight, faBoxOpen, faUserTie, faEnvelope, faSignOut, faGauge, faUsers, faCalculator, faSort, faPhone, faLocation, faCamera, faMessage, faChartLine, faUserCog, faMobilePhone, faPlus, faMobileScreenButton)


// Import the component
import SUCCESSALERTBOX from './components/alert_box/success.vue';
import ERRORALERTBOX from './components/alert_box/error.vue';

const app = createApp(App)

const pinia = createPinia()

app.component('font-awesome-icon', FontAwesomeIcon)


// Register the component globally
app.component('SUCCESSALERTBOX', SUCCESSALERTBOX);
app.component('ERRORALERTBOX', ERRORALERTBOX);

app.use(router)
app.use(pinia)

// Fetch data before mounting the app
const initializeApp = async () => {
    
    const admin_store = useAdminStore(); // Access the admin

    const ordersStore = useOrdersStore(); //Access the orders store

    const recordsStore = useRecordsStore(); //Access the orders store

    const customers_store = useCustomersStore()

    const staffs_store = useStaffsStore()

    const products_store = useProductStore()

    const categoriesStore = useCategoriesStore();

    const settingStore = useSettingStore();
    
    try {

        await admin_store.fetch_admin().catch(err => { // Try to fetch user but DON'T block the app if it fails

            console.log("Admin fetch failed (not logged in).", err); 
          
        });

        if (admin_store.isAuthenticated) {

            await Promise.all([
    
            ordersStore.fetch_orders(),

            recordsStore.fetch_records(),

            products_store.fetch_products(),

            customers_store.fetch_customers(),

            staffs_store.fetch_staffs(),

            categoriesStore.fetch_categories(),

            settingStore.fetch_settings()
    
            ]);
        }       
    
    } catch (error) {
    
        console.log("Error during initialization:", error);

    }
  
    app.mount('#app'); // Mount the app only after data is fetched
  
};
  
initializeApp();
